import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { Helmet } from 'react-helmet';
import Icon from '../../components/AppIcon';
import Header from '../../components/ui/Header';
import TeamIntroduction from './components/TeamIntroduction';
import AttorneyProfile from './components/AttorneyProfile';
import TeamCollaboration from './components/TeamCollaboration';

const TeamProfiles = () => {
  const [currentLanguage, setCurrentLanguage] = useState('en');

  useEffect(() => {
    const savedLanguage = localStorage.getItem('language') || 'en';
    setCurrentLanguage(savedLanguage);
  }, []);

  const attorneys = [
    {
      id: 1,
      name: "Peter Mugambi Muthuri",
      title: currentLanguage === 'en' ? 'Senior Partner & Managing Director' : 'Mshirika Mkuu na Mkurugenzi Mkuu',
      image: "https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?w=400&h=400&fit=crop&crop=face",
      phone: "+254721320787",
      shortBio: currentLanguage === 'en'
        ? "A seasoned legal practitioner with over 10 years of experience in corporate law, litigation, and regulatory compliance. Peter leads the firm with a vision of providing comprehensive legal solutions that drive business success." :"Mwanasheria mzoefu na uzoefu wa zaidi ya miaka 10 katika sheria ya makampuni, mashtaka, na kufuata kanuni. Peter anaongoza kampuni kwa maono ya kutoa suluhisho kamili za kisheria zinazosukuma mafanikio ya biashara.",
      biography: currentLanguage === 'en' ? `Peter Mugambi Muthuri is the founding Senior Partner and Managing Director of Peter & Partners Advocates LLP. With over a decade of legal practice, Peter has established himself as a leading authority in corporate law, commercial litigation, and regulatory compliance in Kenya.\n\nPeter's legal career began at one of Nairobi's most prestigious law firms, where he quickly distinguished himself through his analytical skills and client-focused approach. His expertise spans across multiple practice areas, with particular strength in corporate transactions, mergers and acquisitions, employment law, and dispute resolution.\n\nThroughout his career, Peter has successfully represented multinational corporations, local businesses, and individual clients in complex legal matters. His strategic approach to legal problem-solving and commitment to achieving favorable outcomes has earned him recognition as one of Kenya's rising legal talents.\n\nPeter is known for his ability to translate complex legal concepts into practical business solutions, making him a trusted advisor to CEOs, business owners, and entrepreneurs across various industries. His leadership style emphasizes collaboration, innovation, and unwavering commitment to client success.`
        : `Peter Mugambi Muthuri ni Mshirika Mkuu wa kuanzisha na Mkurugenzi Mkuu wa Peter & Partners Advocates LLP. Akiwa na uzoefu wa zaidi ya muongo mmoja wa mazoea ya kisheria, Peter amejithibitisha kama mkuu wa mamlaka katika sheria ya makampuni, mashtaka ya kibiashara, na kufuata kanuni nchini Kenya.\n\nKazi ya kisheria ya Peter ilianza katika mojawapo ya makampuni ya sheria yenye heshima zaidi Nairobi, ambapo haraka alijitofautisha kupitia ujuzi wake wa uchambuzi na mbinu inayolenga mteja. Utaalamu wake unaenea katika maeneo mengi ya mazoea, hasa katika miamala ya makampuni, uunganishaji na ununuzi, sheria ya ajira, na utatuzi wa migogoro.\n\nKatika kazi yake yote, Peter amefanikiwa kuwakilisha makampuni ya kimataifa, biashara za ndani, na wateja binafsi katika mambo magumu ya kisheria. Mbinu yake ya kimkakati ya kutatua matatizo ya kisheria na kujitolea kupata matokeo mazuri imempatia utambulisho kama mmoja wa vipaji vya kisheria vinavyoongezeka nchini Kenya.\n\nPeter anajulikana kwa uwezo wake wa kutafsiri dhana ngumu za kisheria kuwa suluhisho za vitendo vya biashara, na kumfanya mshauri wa kuaminika kwa wakurugenzi wakuu, wamiliki wa biashara, na wajasiriamali katika tasnia mbalimbali. Mtindo wake wa uongozi unasisitiza ushirikiano, uvumbuzi, na kujitolea bila kuchoka kwa mafanikio ya wateja.`,
      education: [
        currentLanguage === 'en' ? "Bachelor of Laws (LL.B) - University of Nairobi, 2012" : "Shahada ya Kwanza ya Sheria (LL.B) - Chuo Kikuu cha Nairobi, 2012",
        currentLanguage === 'en' ? "Diploma in Law - Kenya School of Law, 2013" : "Diploma ya Sheria - Shule ya Sheria ya Kenya, 2013",
        currentLanguage === 'en' ? "Certificate in Corporate Governance - Institute of Directors Kenya, 2018" : "Cheti cha Utawala wa Makampuni - Taasisi ya Wakurugenzi Kenya, 2018",
        currentLanguage === 'en' ? "Advanced Certificate in Arbitration - Chartered Institute of Arbitrators, 2020" : "Cheti cha Juu cha Uongozi - Taasisi ya Chati ya Waongozi, 2020"
      ],
      barAdmissions: [
        currentLanguage === 'en' ? "Advocate of the High Court of Kenya - 2014" : "Mwanasheria wa Mahakama Kuu ya Kenya - 2014",
        currentLanguage === 'en' ? "Commissioner for Oaths - 2015" : "Kamishna wa Viapo - 2015",
        currentLanguage === 'en' ? "Notary Public - 2016" : "Notari ya Umma - 2016"
      ],
      practiceAreas: [
        {
          name: currentLanguage === 'en' ? 'Corporate Law' : 'Sheria ya Makampuni',
          description: currentLanguage === 'en' ? 'Company formation, governance, and compliance' : 'Uundaji wa makampuni, utawala, na kufuata sheria'
        },
        {
          name: currentLanguage === 'en' ? 'Commercial Litigation' : 'Mashtaka ya Kibiashara',
          description: currentLanguage === 'en' ? 'Business disputes and contract enforcement' : 'Migogoro ya biashara na utekelezaji wa mikataba'
        },
        {
          name: currentLanguage === 'en' ? 'Employment Law' : 'Sheria ya Ajira',
          description: currentLanguage === 'en' ? 'Workplace relations and labor disputes' : 'Mahusiano ya kazini na migogoro ya kazi'
        },
        {
          name: currentLanguage === 'en' ? 'Real Estate Law' : 'Sheria ya Mali',
          description: currentLanguage === 'en' ? 'Property transactions and land law' : 'Miamala ya mali na sheria ya ardhi'
        }
      ],
      memberships: [
        currentLanguage === 'en' ? "Law Society of Kenya (LSK)" : "Chama cha Sheria cha Kenya (LSK)",
        currentLanguage === 'en' ? "East Africa Law Society (EALS)" : "Chama cha Sheria cha Afrika Mashariki (EALS)",
        currentLanguage === 'en' ? "International Bar Association (IBA)" : "Chama cha Kimataifa cha Mawakili (IBA)",
        currentLanguage === 'en' ? "Chartered Institute of Arbitrators (CIArb)" : "Taasisi ya Chati ya Waongozi (CIArb)"
      ],
      achievements: [
        {
          title: currentLanguage === 'en' ? 'Rising Legal Star Award' : 'Tuzo ya Nyota Inayoongezeka ya Kisheria',
          description: currentLanguage === 'en' ? 'Recognized by Kenya Legal Awards for outstanding contribution to corporate law practice' : 'Kutambuliwa na Tuzo za Kisheria za Kenya kwa mchango mkuu katika mazoea ya sheria ya makampuni',year: '2021'
        },
        {
          title: currentLanguage === 'en' ? 'Best Corporate Lawyer - Nairobi' : 'Mwanasheria Bora wa Makampuni - Nairobi',
          description: currentLanguage === 'en' ? 'Awarded by Business Daily for excellence in corporate legal services' : 'Kutuzwa na Business Daily kwa ubora katika huduma za kisheria za makampuni',year: '2022'
        },
        {
          title: currentLanguage === 'en' ? 'Pro Bono Service Recognition' : 'Utambulisho wa Huduma ya Pro Bono',
          description: currentLanguage === 'en' ? 'Honored for providing free legal services to underprivileged communities' : 'Kutukuzwa kwa kutoa huduma za bure za kisheria kwa jamii zilizobaguliwa',year: '2023'
        }
      ],
      testimonials: [
        {
          content: currentLanguage === 'en' ? "Peter's expertise in corporate law is unmatched. He guided us through a complex merger with professionalism and strategic insight.": "Utaalamu wa Peter katika sheria ya makampuni hauna kifani. Alituongoza kupitia muunganishaji mgumu kwa utaalamu na maarifa ya kimkakati.",client: "Sarah Kimani",
          case: currentLanguage === 'en' ? "Corporate Merger" : "Muunganishaji wa Makampuni"
        },
        {
          content: currentLanguage === 'en' ? "Outstanding legal representation. Peter's attention to detail and client-focused approach made all the difference in our case." :"Uwakilishi wa hali ya juu wa kisheria. Umakini wa Peter na mbinu inayolenga mteja ilifanya tofauti yote katika kesi yetu.",
          client: "David Ochieng",
          case: currentLanguage === 'en' ? "Employment Dispute" : "Mgogoro wa Ajira"
        }
      ],
      publications: [
        {
          title: currentLanguage === 'en' ? 'Corporate Governance in Kenya: Best Practices and Challenges' : 'Utawala wa Makampuni nchini Kenya: Mazoea Bora na Changamoto',
          description: currentLanguage === 'en' ? 'An in-depth analysis of corporate governance frameworks and their implementation in Kenyan businesses.' : 'Uchambuzi wa kina wa miundo ya utawala wa makampuni na utekelezaji wake katika biashara za Kenya.',
          publication: currentLanguage === 'en' ? 'Kenya Law Review' : 'Mapitio ya Sheria ya Kenya',
          date: currentLanguage === 'en' ? 'March 2023' : 'Machi 2023'
        },
        {
          title: currentLanguage === 'en' ? 'Employment Law Reforms: Impact on Kenyan Businesses' : 'Marekebisho ya Sheria ya Ajira: Athari kwa Biashara za Kenya',
          description: currentLanguage === 'en' ? 'Examining recent changes in employment legislation and their practical implications for employers.' : 'Kuchunguza mabadiliko ya hivi karibuni katika sheria ya ajira na athari zake za vitendo kwa waajiri.',
          publication: currentLanguage === 'en' ? 'Business Law Journal' : 'Jarida la Sheria ya Biashara',
          date: currentLanguage === 'en' ? 'August 2022' : 'Agosti 2022'
        }
      ],
      speakingEngagements: [
        {
          event: currentLanguage === 'en' ? 'Kenya Corporate Law Conference 2023' : 'Mkutano wa Sheria ya Makampuni ya Kenya 2023',
          date: currentLanguage === 'en' ? 'November 2023' : 'Novemba 2023'
        },
        {
          event: currentLanguage === 'en' ? 'East Africa Legal Summit 2022' : 'Mkutano Mkuu wa Kisheria wa Afrika Mashariki 2022',
          date: currentLanguage === 'en' ? 'September 2022' : 'Septemba 2022'
        }
      ]
    },
    {
      id: 2,
      name: "Judy Nyakio Muriithi",
      title: currentLanguage === 'en' ? 'Partner & Head of Litigation' : 'Mshirika na Mkuu wa Mashtaka',
      image: "https://images.unsplash.com/photo-1494790108755-2616b612b786?w=400&h=400&fit=crop&crop=face",
      phone: "+254721320787",
      shortBio: currentLanguage === 'en'
        ? "A distinguished litigation specialist with 8 years of experience in civil and commercial disputes. Judy brings exceptional courtroom advocacy skills and a strategic approach to complex legal challenges." :"Mtaalamu wa heshima wa mashtaka na uzoefu wa miaka 8 katika migogoro ya kiraia na kibiashara. Judy analeta ujuzi wa kipekee wa utetezi mahakamani na mbinu ya kimkakati kwa changamoto ngumu za kisheria.",
      biography: currentLanguage === 'en'? `Judy Nyakio Muriithi is a Partner and Head of Litigation at Peter & Partners Advocates LLP, bringing over eight years of specialized experience in civil and commercial litigation. Her exceptional advocacy skills and strategic legal thinking have made her one of the most sought-after litigation lawyers in Kenya.\n\nJudy's legal journey began with a strong academic foundation, graduating with honors from her law degree. She quickly established herself in the litigation field, handling complex commercial disputes, family law matters, and civil rights cases. Her courtroom presence and persuasive advocacy have resulted in numerous successful outcomes for her clients.\n\nAs Head of Litigation, Judy oversees all dispute resolution matters at the firm, from pre-litigation strategy to trial advocacy and appeals. She is particularly skilled in alternative dispute resolution methods, including mediation and arbitration, often helping clients achieve favorable settlements without the need for protracted court proceedings.\n\nJudy's approach to litigation is both strategic and compassionate. She understands that legal disputes can be emotionally and financially draining for clients, and she works diligently to provide clear communication, realistic expectations, and cost-effective solutions. Her ability to simplify complex legal issues and her dedication to client service have earned her a reputation as a trusted legal advisor.\n\nBeyond her litigation practice, Judy is actively involved in legal education and mentorship programs, particularly focusing on supporting young female lawyers entering the profession.`
        : `Judy Nyakio Muriithi ni Mshirika na Mkuu wa Mashtaka katika Peter & Partners Advocates LLP, akileta uzoefu wa zaidi ya miaka minane ya utaalamu katika mashtaka ya kiraia na kibiashara. Ujuzi wake wa kipekee wa utetezi na mawazo ya kimkakati ya kisheria yamemfanya mmoja wa mawakili wa mashtaka wanaotafutwa zaidi nchini Kenya.\n\nSafari ya kisheria ya Judy ilianza na msingi imara wa kitaaluma, akihitimu kwa heshima kutoka shahada yake ya sheria. Haraka alijithibitisha katika uwanda wa mashtaka, akishughulikia migogoro magumu ya kibiashara, mambo ya sheria ya familia, na kesi za haki za kiraia. Uwepo wake mahakamani na utetezi wa kushawishi umeongoza matokeo mengi ya mafanikio kwa wateja wake.\n\nKama Mkuu wa Mashtaka, Judy anasimamia mambo yote ya utatuzi wa migogoro katika kampuni, kutoka mkakati wa kabla ya mashtaka hadi utetezi wa majaribio na rufaa. Ana ujuzi maalum katika njia mbadala za utatuzi wa migogoro, ikiwa ni pamoja na uongozi na uongozi, mara nyingi akiwasaidia wateja kupata makubaliano mazuri bila hitaji la michakato ya mahakama ya muda mrefu.\n\nMbinu ya Judy ya mashtaka ni ya kimkakati na ya huruma. Anaelewa kwamba migogoro ya kisheria inaweza kuwa ya kihisia na kifedha kwa wateja, na anafanya kazi kwa bidii kutoa mawasiliano wazi, matarajio ya kweli, na suluhisho za gharama nafuu. Uwezo wake wa kurahisisha masuala magumu ya kisheria na kujitolea kwake kwa huduma za wateja kumempatia sifa kama mshauri wa kisheria wa kuaminika.\n\nZaidi ya mazoea yake ya mashtaka, Judy anashiriki kikamilifu katika elimu ya kisheria na mipango ya uongozi, hasa akilenga kusaidia mawakili wanawake vijana wanaoingia katika taaluma.`,
      education: [
        currentLanguage === 'en' ? "Bachelor of Laws (LL.B) - Kenyatta University, 2014" : "Shahada ya Kwanza ya Sheria (LL.B) - Chuo Kikuu cha Kenyatta, 2014",
        currentLanguage === 'en' ? "Diploma in Law - Kenya School of Law, 2015" : "Diploma ya Sheria - Shule ya Sheria ya Kenya, 2015",
        currentLanguage === 'en' ? "Certificate in Alternative Dispute Resolution - Strathmore University, 2019" : "Cheti cha Utatuzi wa Migogoro Mbadala - Chuo Kikuu cha Strathmore, 2019",
        currentLanguage === 'en' ? "Advanced Advocacy Skills - Kenya Law Society, 2021" : "Ujuzi wa Juu wa Utetezi - Chama cha Sheria cha Kenya, 2021"
      ],
      barAdmissions: [
        currentLanguage === 'en' ? "Advocate of the High Court of Kenya - 2016" : "Mwanasheria wa Mahakama Kuu ya Kenya - 2016",
        currentLanguage === 'en' ? "Commissioner for Oaths - 2017" : "Kamishna wa Viapo - 2017",
        currentLanguage === 'en' ? "Certified Mediator - 2020" : "Mpatanishi Aliyethibitishwa - 2020"
      ],
      practiceAreas: [
        {
          name: currentLanguage === 'en' ? 'Civil Litigation' : 'Mashtaka ya Kiraia',
          description: currentLanguage === 'en' ? 'Complex civil disputes and tort claims' : 'Migogoro magumu ya kiraia na madai ya uhalifu'
        },
        {
          name: currentLanguage === 'en' ? 'Family Law' : 'Sheria ya Familia',
          description: currentLanguage === 'en' ? 'Divorce, custody, and matrimonial matters' : 'Talaka, ulinzi, na mambo ya ndoa'
        },
        {
          name: currentLanguage === 'en' ? 'Commercial Disputes' : 'Migogoro ya Kibiashara',
          description: currentLanguage === 'en' ? 'Business litigation and contract disputes' : 'Mashtaka ya biashara na migogoro ya mikataba'
        },
        {
          name: currentLanguage === 'en' ? 'Alternative Dispute Resolution' : 'Utatuzi wa Migogoro Mbadala',
          description: currentLanguage === 'en' ? 'Mediation and arbitration services' : 'Huduma za upatanishi na uongozi'
        }
      ],
      memberships: [
        currentLanguage === 'en' ? "Law Society of Kenya (LSK)" : "Chama cha Sheria cha Kenya (LSK)",
        currentLanguage === 'en' ? "Kenya Women Lawyers Association (KWLA)" : "Chama cha Mawakili Wanawake wa Kenya (KWLA)",
        currentLanguage === 'en' ? "Chartered Institute of Arbitrators (CIArb)" : "Taasisi ya Chati ya Waongozi (CIArb)",
        currentLanguage === 'en' ? "International Association of Women Lawyers (IAWL)" : "Chama cha Kimataifa cha Mawakili Wanawake (IAWL)"
      ],
      achievements: [
        {
          title: currentLanguage === 'en' ? 'Outstanding Litigation Lawyer Award' : 'Tuzo ya Mwanasheria Bora wa Mashtaka',
          description: currentLanguage === 'en' ? 'Recognized by Kenya Legal Awards for excellence in civil litigation practice' : 'Kutambuliwa na Tuzo za Kisheria za Kenya kwa ubora katika mazoea ya mashtaka ya kiraia',year: '2022'
        },
        {
          title: currentLanguage === 'en' ? 'Women in Law Leadership Award' : 'Tuzo ya Uongozi wa Wanawake katika Sheria',
          description: currentLanguage === 'en' ? 'Honored for contributions to advancing women in the legal profession' : 'Kutukuzwa kwa michango ya kuendeleza wanawake katika taaluma ya kisheria',year: '2023'
        },
        {
          title: currentLanguage === 'en' ? 'Community Service Excellence' : 'Ubora wa Huduma za Kijamii',
          description: currentLanguage === 'en' ? 'Awarded for pro bono work in family law and women\'s rights' : 'Kutuzwa kwa kazi ya pro bono katika sheria ya familia na haki za wanawake',
          year: '2021'
        }
      ],
      testimonials: [
        {
          content: currentLanguage === 'en' ? "Judy's expertise in family law is exceptional. She handled our custody case with sensitivity and achieved the best possible outcome for our family." :"Utaalamu wa Judy katika sheria ya familia ni wa kipekee. Alishughulikia kesi yetu ya ulinzi kwa hisia na kupata matokeo bora zaidi kwa familia yetu.",
          client: "Grace Wanjiku",
          case: currentLanguage === 'en' ? "Child Custody" : "Ulinzi wa Mtoto"
        },
        {
          content: currentLanguage === 'en' ? "Professional, knowledgeable, and results-oriented. Judy's litigation skills are top-notch and she kept us informed throughout the process." :"Kitaalamu, mwenye maarifa, na anayelenga matokeo. Ujuzi wa Judy wa mashtaka ni wa hali ya juu na alituweka tumefahamishwa katika mchakato wote.",
          client: "Michael Kiprotich",
          case: currentLanguage === 'en' ? "Commercial Dispute" : "Mgogoro wa Kibiashara"
        }
      ],
      publications: [
        {
          title: currentLanguage === 'en' ? 'Family Law Reforms in Kenya: Protecting Children\'s Rights' : 'Marekebisho ya Sheria ya Familia nchini Kenya: Kulinda Haki za Watoto',
          description: currentLanguage === 'en' ? 'Analysis of recent amendments to family law legislation and their impact on child welfare.' : 'Uchambuzi wa marekebisho ya hivi karibuni ya sheria ya familia na athari zake kwa ustawi wa watoto.',
          publication: currentLanguage === 'en' ? 'Family Law Quarterly' : 'Robo Mwaka wa Sheria ya Familia',
          date: currentLanguage === 'en' ? 'June 2023' : 'Juni 2023'
        },
        {
          title: currentLanguage === 'en' ? 'Alternative Dispute Resolution: A Practical Guide for Kenyan Lawyers' : 'Utatuzi wa Migogoro Mbadala: Mwongozo wa Vitendo kwa Mawakili wa Kenya',
          description: currentLanguage === 'en' ? 'Comprehensive guide to mediation and arbitration practices in Kenya.' : 'Mwongozo kamili wa mazoea ya upatanishi na uongozi nchini Kenya.',
          publication: currentLanguage === 'en' ? 'Kenya Law Journal' : 'Jarida la Sheria ya Kenya',
          date: currentLanguage === 'en' ? 'January 2022' : 'Januari 2022'
        }
      ],
      speakingEngagements: [
        {
          event: currentLanguage === 'en' ? 'Women in Law Conference 2023' : 'Mkutano wa Wanawake katika Sheria 2023',
          date: currentLanguage === 'en' ? 'October 2023' : 'Oktoba 2023'
        },
        {
          event: currentLanguage === 'en' ? 'Alternative Dispute Resolution Workshop 2022' : 'Warsha ya Utatuzi wa Migogoro Mbadala 2022',
          date: currentLanguage === 'en' ? 'July 2022' : 'Julai 2022'
        }
      ]
    }
  ];

  return (
    <div className="min-h-screen bg-background">
      <Helmet>
        <title>
          {currentLanguage === 'en' ?'Our Team - Peter & Partners Advocates LLP' :'Timu Yetu - Peter & Partners Advocates LLP'}
        </title>
        <meta 
          name="description" 
          content={currentLanguage === 'en' ?'Meet the experienced legal team at Peter & Partners Advocates LLP. Learn about Peter Mugambi Muthuri and Judy Nyakio Muriithi, their expertise, and professional backgrounds.' :'Kutana na timu ya kisheria yenye uzoefu katika Peter & Partners Advocates LLP. Jifunze kuhusu Peter Mugambi Muthuri na Judy Nyakio Muriithi, utaalamu wao, na mazingira yao ya kitaalamu.'}
        />
      </Helmet>

      <Header />

      <main className="max-w-7xl mx-auto px-6 lg:px-8 py-8">
        {/* Breadcrumb */}
        <nav className="flex items-center space-x-2 text-sm text-text-secondary mb-8">
          <Link to="/homepage" className="hover:text-primary transition-colors duration-200">
            {currentLanguage === 'en' ? 'Home' : 'Nyumbani'}
          </Link>
          <Icon name="ChevronRight" size={16} />
          <span className="text-text-primary font-medium">
            {currentLanguage === 'en' ? 'Our Team' : 'Timu Yetu'}
          </span>
        </nav>

        {/* Team Introduction */}
        <div className="mb-12">
          <TeamIntroduction currentLanguage={currentLanguage} />
        </div>

        {/* Attorney Profiles */}
        <div className="space-y-12 mb-12">
          {attorneys.map((attorney) => (
            <AttorneyProfile 
              key={attorney.id} 
              attorney={attorney} 
              currentLanguage={currentLanguage} 
            />
          ))}
        </div>

        {/* Team Collaboration */}
        <div className="mb-12">
          <TeamCollaboration currentLanguage={currentLanguage} />
        </div>

        {/* Contact Call-to-Action */}
        <div className="bg-gradient-to-r from-primary/10 to-accent/10 rounded-lg p-8 text-center">
          <h2 className="text-2xl lg:text-3xl font-heading font-bold text-text-primary mb-4">
            {currentLanguage === 'en' ? 'Ready to Work with Our Team?' : 'Tayari Kufanya Kazi na Timu Yetu?'}
          </h2>
          <p className="text-text-secondary mb-6 max-w-2xl mx-auto">
            {currentLanguage === 'en' ?'Contact Peter & Partners Advocates LLP today to schedule a consultation with our experienced legal team. We\'re here to help you navigate your legal challenges with confidence.' :'Wasiliana na Peter & Partners Advocates LLP leo kupanga mazungumzo na timu yetu ya kisheria yenye uzoefu. Tuko hapa kukusaidia kupitia changamoto zako za kisheria kwa ujasiri.'}
          </p>
          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <Link to="/contact-us">
              <button className="bg-primary text-white px-6 py-3 rounded-lg font-medium hover:bg-accent transition-colors duration-200 flex items-center space-x-2">
                <Icon name="Phone" size={20} />
                <span>{currentLanguage === 'en' ? 'Schedule Consultation' : 'Panga Mazungumzo'}</span>
              </button>
            </Link>
            <button 
              onClick={() => {
                const message = encodeURIComponent(currentLanguage === 'en' ?'Hello, I would like to schedule a consultation with your legal team.' :'Hujambo, ningependa kupanga mazungumzo na timu yenu ya kisheria.');
                window.open(`https://wa.me/+254721320787?text=${message}`, '_blank');
              }}
              className="bg-success text-white px-6 py-3 rounded-lg font-medium hover:bg-success/90 transition-colors duration-200 flex items-center space-x-2"
            >
              <Icon name="MessageCircle" size={20} />
              <span>WhatsApp</span>
            </button>
          </div>
        </div>
      </main>

      {/* Footer */}
      <footer className="bg-text-primary text-white py-12 mt-16">
        <div className="max-w-7xl mx-auto px-6 lg:px-8">
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
            {/* Company Info */}
            <div>
              <div className="flex items-center space-x-3 mb-4">
                <div className="flex items-center justify-center w-10 h-10 bg-primary rounded-lg">
                  <Icon name="Scale" size={24} color="white" />
                </div>
                <div>
                  <h3 className="font-heading font-bold text-lg">Peter Partners</h3>
                  <p className="text-sm opacity-80">
                    {currentLanguage === 'en' ? 'Law Firm' : 'Kampuni ya Sheria'}
                  </p>
                </div>
              </div>
              <p className="text-sm opacity-80 leading-relaxed">
                {currentLanguage === 'en' ?'Professional legal services with a commitment to excellence, integrity, and client success.' :'Huduma za kisheria za kitaalamu na kujitolea kwa ubora, uongozi, na mafanikio ya wateja.'}
              </p>
            </div>

            {/* Contact Info */}
            <div>
              <h4 className="font-semibold mb-4">
                {currentLanguage === 'en' ? 'Contact Information' : 'Maelezo ya Mawasiliano'}
              </h4>
              <div className="space-y-2 text-sm">
                <div className="flex items-center space-x-2">
                  <Icon name="Phone" size={16} />
                  <span>+254 721 320 787</span>
                </div>
                <div className="flex items-center space-x-2">
                  <Icon name="Mail" size={16} />
                  <span>info@peterpartnerslaw.co.ke</span>
                </div>
                <div className="flex items-center space-x-2">
                  <Icon name="MapPin" size={16} />
                  <span>Nairobi, Kenya</span>
                </div>
              </div>
            </div>

            {/* Quick Links */}
            <div>
              <h4 className="font-semibold mb-4">
                {currentLanguage === 'en' ? 'Quick Links' : 'Viungo vya Haraka'}
              </h4>
              <div className="space-y-2 text-sm">
                <Link to="/homepage" className="block hover:text-primary transition-colors duration-200">
                  {currentLanguage === 'en' ? 'Home' : 'Nyumbani'}
                </Link>
                <Link to="/practice-areas-overview" className="block hover:text-primary transition-colors duration-200">
                  {currentLanguage === 'en' ? 'Practice Areas' : 'Maeneo ya Utendaji'}
                </Link>
                <Link to="/about-us" className="block hover:text-primary transition-colors duration-200">
                  {currentLanguage === 'en' ? 'About Us' : 'Kuhusu Sisi'}
                </Link>
                <Link to="/contact-us" className="block hover:text-primary transition-colors duration-200">
                  {currentLanguage === 'en' ? 'Contact' : 'Wasiliana'}
                </Link>
              </div>
            </div>
          </div>

          <div className="border-t border-white/20 mt-8 pt-8 text-center text-sm opacity-80">
            <p>&copy; {new Date().getFullYear()} Peter & Partners Advocates LLP. {currentLanguage === 'en' ? 'All rights reserved.' : 'Haki zote zimehifadhiwa.'}</p>
          </div>
        </div>
      </footer>
    </div>
  );
};

export default TeamProfiles;